import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../useAuth';

export default function Landing() {
  const { user } = useAuth();
  return (
    <main className="min-h-screen bg-neutral-950 text-neutral-100 flex items-center justify-center px-6">
      <div className="max-w-2xl text-center">
        <h1 className="text-5xl font-semibold tracking-tight mb-4">ShrewdHedge</h1>
        <p className="text-lg text-neutral-400 mb-8">
          AI-powered portfolio management. The shrewd hedge for the modern investor.
        </p>
        <p className="text-sm text-neutral-500 mb-10">
          Connect your accounts, see your real allocation, and get an honest read
          from an AI co-pilot that has access to the same data the pros do.
        </p>
        {user ? (
          <Link
            to="/dashboard"
            className="inline-block px-6 py-3 rounded bg-indigo-500 hover:bg-indigo-400 text-white font-medium"
          >
            Go to dashboard
          </Link>
        ) : (
          <div className="flex gap-3 justify-center">
            <Link
              to="/signup"
              className="px-6 py-3 rounded bg-indigo-500 hover:bg-indigo-400 text-white font-medium"
            >
              Create account
            </Link>
            <Link
              to="/signin"
              className="px-6 py-3 rounded border border-neutral-700 hover:border-neutral-500 text-neutral-200 font-medium"
            >
              Sign in
            </Link>
          </div>
        )}
      </div>
    </main>
  );
}
